module.exports = __webpack_public_path__ + "img/loading-logo-animation.b26f8853.gif";